module.exports = __webpack_public_path__ + "static/media/img_cards.8396581d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/img_cards.png
// module id = 340
// module chunks = 0